import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { partnerTransfers as rules } from 'further-ui/validations';
import { PartnerTransferSection } from 'further-types/lp/partner-transfer';
import { CalendarDay } from 'further-ui/utils';
const formSchema = rules.CreatePartnerTransfer;

export type PartnerTransfersFormValues = z.infer<typeof formSchema>;

type UsePartnerTransfersFormProps = {
  defaultValues?: Partial<PartnerTransfersFormValues>;
};

export default function usePartnerTransfersForm({
  defaultValues: providedDefaultValues,
}: UsePartnerTransfersFormProps = {}) {
  const defaultValues: PartnerTransfersFormValues = {
    currentSection: PartnerTransferSection.PartnerTransfer,
    actions: [
      { section: PartnerTransferSection.Investments, actions: [] },
      { section: PartnerTransferSection.Expenses, actions: [] },
      { section: PartnerTransferSection.Income, actions: [] },
    ],
    partnerTransferId: '',
    trasferrorCommitmentId: '',
    transferDate: new CalendarDay(new Date()),
    transferees: [
      {
        investorLabel: '',
        investorId: '',
        amountLcy: 0,
        percentage: 0,
      },
    ],
    capitalActionTransactions: {},
    feeTransactions: {},
    ...providedDefaultValues,
  };

  const formMethods = useForm<PartnerTransfersFormValues>({
    shouldFocusError: true,
    resolver: zodResolver(formSchema),
    defaultValues,
    values: providedDefaultValues ? defaultValues : undefined,
    criteriaMode: 'all',
    resetOptions: {
      keepDefaultValues: false,
    },
  });

  return {
    formMethods,
  };
}
